export default __webpack_public_path__ + "77c6a5aafbb8a5a4b220494a143cabfe.svg";